var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-handling-container"},[_c('div',{staticClass:"event-title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"event-list-wrapper"})])
}]

export { render, staticRenderFns }